import styled from 'styled-components';

export const ImageWithDataStyles = styled.section`
  body.dark & {
    --user-info-content-background: #803eff12;
    --user-info-content-value-background: #ffffff1a;
  }

  --user-info-content-background: #803eff0d;
  --user-info-content-value-background: #803eff1a;

  padding: 15px 0 0;
  margin: 0 0 16px;

  .image-with-data-title {
    max-width: 300px;
    padding: 0 10px;
    margin-bottom: 16px;

    @media screen and (min-width: 768px) {
      max-width: 540px;
    }
  }

  .image-with-data-container {
    width: 100%;
    margin: 0px auto 50px;
    max-width: 380px;
    position: relative;
  }

  .image-with-data-container-img-wrapper {
    position: absolute;
    top: 0;
    left: -34px;
    max-width: 220px;
    z-index: -1;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .image-with-data-user-info {
    &__content {
      min-height: 250px;
      max-width: 180px;
      border-radius: 16px;
      padding: 16px;
      margin-left: auto;
      margin-right: 16px;
      background: var(--user-info-content-background);
      backdrop-filter: blur(10px);

      &-title {
        margin: 0 0 8px;
      }

      &-values {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &-value {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 4px 8px;
        background: var(--user-info-content-value-background);
        border-radius: 16px;

        img {
          width: 13px;
          height: 13px;
          font-size: 13px;
          line-height: 0;
          border-radius: 10px;
        }
      }
    }
  }
`;
